import React from 'react'
import { Box, Chip, Paper, Typography } from '@mui/material'

import { isAnalyzerLoading } from 'Pages/AnalyzersV2/@signals'
import { buildVerdict } from 'Pages/AnalyzersV2/@components/PositionVerdict/@utils'


export default function PositionVerdict({ mainData, mainName }) {
	if (isAnalyzerLoading.value) return null

	const verdict = buildVerdict(mainData, mainName)

	if (!verdict) return null

	const { deltaText, rankText, cheapestText, isOftenCheapest, underText, stanceText } = verdict

	return <Paper
		variant="outlined"
		sx={{ p: 2, borderLeft: 4, borderLeftColor: 'primary.main' }}>
		<Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: .5 }}>
			<Typography variant="body2" sx={{ fontWeight: 'bold' }}>Read:</Typography>

			<Typography variant="body2" component="span">
				{mainName} sits
			</Typography>
			{!!deltaText && <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{deltaText}</Typography>}
			<Typography variant="body2" component="span">
				vs the blended market average
			</Typography>

			{!!rankText && <>
				<Typography variant="body2" component="span">and ranks</Typography>
				<Typography variant="body2" sx={{ fontWeight: 'bold' }}>{rankText}</Typography>
			</>}

			{!!cheapestText && <Chip
				label={cheapestText}
				size="small"
				sx={{
					height: 20,
					fontSize: 11,
					fontWeight: 'bold',
					color: isOftenCheapest ? 'success.dark' : 'error.main',
					backgroundColor: isOftenCheapest ? 'success.lighter' : 'error.lighter',
				}}
			/>}

			<Typography variant="body2" component="span">{underText}</Typography>
			{!!stanceText && <Typography variant="body2" component="span">{stanceText}</Typography>}
		</Box>
	</Paper>
}
